// extracted by mini-css-extract-plugin
export var dropdown = "dropdown-module--dropdown--1bCYC";
export var btn = "dropdown-module--btn--2ODYC";
export var dropdownOpen = "dropdown-module--dropdownOpen--GL2Nx";
export var list = "dropdown-module--list--52Dfj";
export var listShow = "dropdown-module--listShow--gqU5o";
export var menu = "dropdown-module--menu--3p1b3";